/**
 * Created by lu on 2018/5/4.
 */
var nb = require('../../nb');
module.exports = nb.define({
    view:{
        id:nb.bind('paginationId'),
        'class':['pagination-wrap']
    },
    method:{
        init:function () {
            
        }
    }
});


//////////////////
// WEBPACK FOOTER
// ../src/js/view/pagination/Pagination.js
// module id = 55
// module chunks = 1 3 11 12 14 16 17 24 31 33